module.exports = __webpack_public_path__ + "img/close3.a54596bf.svg";